import axios from './axiosConfig'

export const getHideFundingByCompanyId = async (id) => {
  const response = await axios.get(`/funding/hide/${id}`)
  console.log(response.data)
  return response.data
}

export const restoreReport = async (id) => {
  const response = await axios.put(`/funding/hide/${id}`)
  return response.data
}

export const restoreCompany = async (id) => {
  const response = await axios.put(`/funding/hide/company/${id}`)
  return response.data
}

export const getCinImageFromFunding = async () => {
  const response = await axios.get('/funding')
  console.log('onlyimagecin:', response.data)
  return response.data
}

export const getDeleteCompany = async () => {
  const response = await axios.get('/funding/company')
  console.log('onlyimagecin:', response.data)
  return response.data
}

export const getFundingByCompanyId = async (id) => {
  const response = await axios.get(`/funding/${id}`)
  console.log('only:', response.data)
  return response.data
}

export const getSingleReportById = async (id) => {
  const response = await axios.get(`/funding/report/${id}`)
  console.log('report only:', response.data)
  return response.data
}

export const getCompanyById = async (id) => {
  const response = await axios.get(`/funding/company/${id}`)
  console.log('response at api', response.data)
  return response.data
}

export const createFunding = async (formData) => {
  const data = new FormData()

  // Required fields
  data.append('pdfPrice', formData.pdfPrice)
  data.append('fundingDetails', formData.fundingDetails)
  data.append('cin', formData.cin)
  data.append('companyName', formData.companyName)
  data.append('fundingDate', formData.fundingDate)

  // File uploads - Fixed: files are File objects, not arrays
  if (formData.companyLogo && formData.companyLogo[0]) {
    data.append('companyLogo', formData.companyLogo[0])
  }

  if (formData.pdfFile && formData.pdfFile[0]) {
    data.append('pdfFile', formData.pdfFile[0])
  }

  try {
    const response = await axios.post('/funding', data, {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    return response.data
  } catch (error) {
    console.error('Error creating insight:', error)
    throw error
  }
}

export const updateFunding = async (id, formData) => {
  const data = new FormData()

  // Required fields - always append these

  data.append('pdfPrice', formData.pdfPrice || '')
  data.append('fundingDetails', formData.fundingDetails || '')
  data.append('fundingDate', formData.fundingDate || '')

  if (formData.pdfFile && formData.pdfFile[0]) {
    data.append('pdfFile', formData.pdfFile[0])
  }
  // // Log FormData contents for debugging
  // for (let [key, value] of data.entries()) {
  //   console.log(`${key}:`, value)
  // }

  try {
    const response = await axios.put(`/funding/${id}`, data, {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    return response.data
  } catch (error) {
    console.error('Error updating deal:', error)
    throw error
  }
}

export const updateFundingCompany = async (id, formData) => {
  const response = await axios.put(`/funding/company/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  console.log('Update company response:', response.data)
  return response.data
}

export const deleteFunding = async (id, otp) => {
  try {
    const response = await axios.delete(`/funding/${id}?otp=${otp}`, {
      withCredentials: true,
    })

    // console.log('Delete funding response:', response.data)
    return response.data
  } catch (error) {
    console.error('Error deleting funding:', error)
    throw error
  }
}

export const sendMail = async (id) => {
  try {
    const response = await axios.get(`/funding/mail/${id}`, {
      withCredentials: true,
    })

    console.log('mail API response type:', response)
    return response
  } catch (error) {
    console.error('Error fetching funding:', error)
    throw error
  }
}

export const deleteCompany = async (id, otp) => {
  try {
    const response = await axios.delete(`/funding/company/${id}?otp=${otp}`, {
      withCredentials: true,
    })

    // console.log('Delete funding response:', response.data)
    return response.data
  } catch (error) {
    console.error('Error deleting funding:', error)
    throw error
  }
}

export const sendMailCompany = async (id) => {
  try {
    const response = await axios.get(`/funding/mail/company/${id}`, {
      withCredentials: true,
    })

    console.log('mail API response type:', response)
    return response
  } catch (error) {
    console.error('Error fetching funding:', error)
    throw error
  }
}
